import React, { FunctionComponent } from 'react'

import { MainLogo } from '../MainLogo/MainLogo'

export const TopBarLogo: FunctionComponent = () => {
  return (
    <a href="https://data.regesta.cz" className="p-4 flex justify-center group">
      <MainLogo className="flex w-3/5" />
    </a>
  )
}
